var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',_vm._g(_vm._b({staticClass:"add-btn px-4 py-2",attrs:{"fab":"","rounded":"","bottom":"","right":"","fixed":"","color":"primary"}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_c('v-icon',{staticClass:"mr-1",attrs:{"size":"14"}},[_vm._v("fal fa-plus")]),_vm._t("btn-text")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }